// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  min-height: 362px;
  width: 95%;
  padding: 15px;
  background-color: white;
  border-radius: 15px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/widgets/last-payments-list/last-payments-list.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,YAAA;AACJ","sourcesContent":["ion-card{\r\n  min-height: 362px;\r\n    width: 95%; \r\n    padding: 15px;\r\n    background-color: white;\r\n    border-radius: 15px;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    margin: auto;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
